<template>
    <div>
        <el-row :gutter="30">
            <el-col :xs="24" :xl="16">
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="30">
                        <el-col><span class="color-info">用户ID: </span>{{formData.userId}}</el-col>
                        <el-col><span class="color-info">用户名称: </span>{{formData.name}}</el-col>
                        <el-col><span class="color-info">用户类型: </span>{{$userType.get(formData.userType)}}</el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props:{
        formData:{
            type: Object,
            default: null
        }
    },
    data(){
        return{}
    }
}
</script>
